import Currency from "slotworks/i18n/currency";
import revolverModel from "slotworks/integration/revolver/model/revolver-model";
import RevolverModel from "slotworks/integration/revolver/model/revolver-model";
import { InitRecordSchema } from "slotworks/integration/revolver/schema/init-record-schema";
import AutoplayModel from "slotworks/model/autoplay-model";
import BetModel from "slotworks/model/bets/bet-model";
import Gameplay from "slotworks/model/gameplay/gameplay-model";
import Record from "slotworks/model/gameplay/records/record";
import SettingsModel from "slotworks/model/settings/settings-model";
import { RealityMode } from "slotworks/model/settings/settings-model";
import SlotDefinition from "slotworks/model/slot-definition";
import { RecordBuilder } from "slotworks/server/builders/record-builder";
import { log } from "util";
import DeviceInfo from "../../../../utils/device-info";
import WrapperMediator from "../../wrapper/wrapper-mediator";

class AuthRecordBuilder implements RecordBuilder {

    public filter(data: any): boolean {
        let initRecord: InitRecordSchema;

        if (data && data.data) {
            initRecord = data.data as InitRecordSchema;
        }

        return initRecord && initRecord.AUTH !== undefined;
    }

    public build(gameplay: Gameplay, data: any): Record[] {
        let initRecord: InitRecordSchema;

        if (data && data.data) {
            initRecord = data.data as InitRecordSchema;
            WrapperMediator.gameDataLoaded(initRecord);
            SettingsModel.authData = initRecord.CONFIG;
        }

        AutoplayModel.autoplaySteps = initRecord.CONFIG.autoSpinOptions;
        if (DeviceInfo.layoutId === "desktop") {
            AutoplayModel.defaultAutoplays = AutoplayModel.autoplaySteps[1];
        } else {
            AutoplayModel.defaultAutoplays = 0;
        }

        SlotDefinition.coinSizes = initRecord.CONFIG.betConfig.creditValues;
        const creditBaseMultiplier = initRecord.CONFIG.betConfig.creditBaseMultiplier || 1;
        revolverModel.creditBaseMultiplier = creditBaseMultiplier;

        // minBetLevel if available, else default to 1
        let minBetLevel = 1;
        if(initRecord.CONFIG.betConfig.minBetLevel && 
                initRecord.CONFIG.betConfig.minBetLevel >= 1 && 
                initRecord.CONFIG.betConfig.minBetLevel <= initRecord.CONFIG.betConfig.maxBetLevel) {
            minBetLevel = initRecord.CONFIG.betConfig.minBetLevel;
        }

        const betLevels = [];
        for (let level = minBetLevel; level <= initRecord.CONFIG.betConfig.maxBetLevel; level++) {
            betLevels.push(level * creditBaseMultiplier);
        }
        SlotDefinition.stakes = betLevels;

        const defaults = initRecord.CONFIG.betConfig.defaultBetState;

        // position of default bet in the array, 1 if not defined
        BetModel.setDefaults(SlotDefinition.stakes[defaults.bet_level - 1], defaults.lines, SlotDefinition.coinSizes[defaults.coin_level - 1]);
        BetModel.setStepper(initRecord.CONFIG.betConfig.stepperValues);

        const lang = SettingsModel.language || initRecord.AUTH.player.lang || "en";
        SettingsModel.availableSocialCurrencies = initRecord.AUTH.available_social_currencies || [];

        if(initRecord.AUTH.currency_multiplier && 
                initRecord.AUTH.currency_multiplier >= 100 && 
                SettingsModel.socialSweepstakes) {
            SettingsModel.removeTrailingDecimals = true;
        }

        Currency.configure(lang, initRecord.AUTH.player.currency, "symbol", SettingsModel.getDisplayCoins(), BetModel.getCoinSize(), initRecord.AUTH.player.isCryptoCurrency);

        SettingsModel.playMode = initRecord.AUTH.is_freeplay ? RealityMode.FREE : RealityMode.REAL;

        gameplay.startBalance = initRecord.USER.balance;
        gameplay.balance = gameplay.startBalance;

        RevolverModel.session = initRecord.AUTH.session;
        RevolverModel.jwt_token = initRecord.AUTH.jwt_token;
        try {
            if (initRecord.CONFIG.sendBetConfigInResult) {
                revolverModel.betConfig = initRecord.CONFIG.betConfig;
                revolverModel.sendBetConfigInResult = true;
            }
        } catch (e) {
            log(e);
        }
        
        const paytableConfig = initRecord.CONFIG.payTableConfig;
        if (paytableConfig) {
            SettingsModel.maxWin = paytableConfig.max_win;
            SettingsModel.maxWinProbability = paytableConfig.max_win_probability;
            if (paytableConfig.rtp && paytableConfig.rtp.total) {
                SettingsModel.rtp = paytableConfig.rtp.total;
            }
        }

        const records: Record[] = [];

        return records;
    }
}

export default new AuthRecordBuilder();



// WEBPACK FOOTER //
// ./~/ifdef-loader/ifdef-loader.js??ref--0-1!./~/slotworks/integration/revolver/builders/records/auth-record-builder.ts